import { apiCall } from "../service/api-service";

export const createInvoiceApi = async (data) => {
  return apiCall("POST", "invoice", data);
};
export const getOrderDetailsApi = async (id) => {
  return apiCall("GET", `get_order_details/${id}`);
};
export const getEditInvoiceDetailsApi = async (id) => {
  return apiCall("GET", `invoice/edit/${id}`);
};
export const updateInvoiceApi = async (data, id) => {
  return apiCall("PUT", `invoice/${id}`, data);
};

export const updateInvoiceStatusApi = async (data, id) => {
  return apiCall("PUT", `invoice/status_update/${id}`, data);
};

export const getInvoiceDetailsApi = async (id) => {
  return apiCall("GET", `invoice/view/${id}`);
};

export const getReturnedProductApi = async (id) => {
  return apiCall("GET", `get_return_products/${id}`);
};

// Get all invoices (list)
export const getInvoiceListApi = async (params = {}) => {
  return apiCall("GET", `invoice${params}`);
};

export const bulkDeleteInvoiceApi = async (ids) => {
  const data = Array.isArray(ids) ? { ids } : ids;
  return apiCall("DELETE", "invoice/bulk_delete", data);
};

export const getHistoryApi = async (id) => {
  return apiCall("GET", `invoice/history/${id}`);
};

export const getWorkflowApi = async (id) => {
  return apiCall("GET", `invoice/workflow/${id}`);
};
export const getStateTaxApi = async (id) => {
  return apiCall("POST", "check_state_tax", { state_id: id });
};
export const getDownloadInvoicePDFApi = async (id, format = 1) => {
  return apiCall("GET", `invoice/download_pdf/${id}?format=${format}`);
};

export const getInvoicePaymentHistoryApi = async (id) => {
  return apiCall("GET", `invoice_payment_history/${id}`);
};

export const deleteInvoicePaymentHistoryApi = async (id) => {
  return apiCall("DELETE", `invoice_payment_history/delete/${id}`);
};

export const downloadInvoicePaymentTemplateApi = async () => {
  return apiCall("GET", "invoice_payment_template_download");
};

export const uploadInvoicePaymentApi = async (data) => {
  return apiCall("POST", "invoice_payment_upload", data);
};

export const askInvoiceChatApi = async (payload) => {
  return apiCall("POST", "invoice/ai_chat", payload);
};

export const getInvoiceAiProvidersApi = async () => {
  return apiCall("GET", "invoice/ai_providers");
};
